import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Table, TableHead, TableCell, TableRow, TableBody, IconButton,
  Typography,
  Box,
  Button, Avatar,
} from "@mui/material";
import { Edit } from "iconsax-react";
import PersonIcon from '@mui/icons-material/Person';
import ReplyRoundedIcon from '@mui/icons-material/ReplyRounded';
import { registerGuestId, editGuestDetail, fetchGuestList, sendEmailUrl } from "../actions";
import Header from "../Components/header";
import NavigationButtons from "../Components/navigationButton";
import GuestEditModal from "../Components/guestModal";
import ConfirmationModal from "../Components/confirmationModal";
import LoadingOverlay from "../Components/Loading/LoadingOverlay";
import Swal from 'sweetalert2'
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

const { URL_PREFIX } = window;

class VF2StepGuest extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      isOpen: false,
      isOpenSend: false,
      isOpenStart: false,
      selectedRow: {},
      selectedGuest: {}
    };
  }

  handleOpen = () => {
    this.setState({ isOpen: true });
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
      selectedRow: {},
    });
  };

  handleOpenSend = () => {
    this.setState({ isOpenSend: true });
  };

  handleCloseSend = () => {
    this.setState({
      isOpenSend: false,
      selectedRow: {},
    });
  };

  handleSelectedRow = (row) => {
    this.setState({
      selectedRow: {
        Id: row.Id,
        name: row.Guest_FullName__r.Name,
        Email_Guest__c: row.Email_Guest__c
      },
    });
  };

  changeFormValue = (key, value) => {
    const { selectedRow } = this.state;
    selectedRow[key] = value;
    this.setState({ selectedRow });
  };

  handleOpenStart = (row, refetch = false) => {
    this.setState({ isOpenStart: true, selectedGuest: {...row, refetch} });
  };

  handleCloseStart = () => {
    this.setState({
      isOpenStart: false,
      selectedGuest: {},
    });
  };

  changeGuest = async (row) => {
    this.setState({ isLoading: true });
    try {
      const {selectedGuest} = this.state
      if(selectedGuest.refetch){
        await this.props.registerGuestId(row.Id);
      }
      this.props.history.push(`${URL_PREFIX}/vf2/wizard/personal`)
    } catch (error) {
      console.error('Error fetching guest details:', error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  sendURLGuest = async (row) => {
    this.setState({ isLoading: true, isOpenSend: false });
    try {
      await this.props.sendEmailUrl(row.Id);
      Swal.fire({
        title: "VF2 URL sent!",
        text: `email sent to ${row.Email_Guest__c}!`,
        type: "success"
      });
    } catch (error) {
      console.error('Error sending guest url:', error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  onSaveGuest = async () => {
    this.setState({ isLoading: true });

    try {
      const Id = this.state.selectedRow?.Id
      this.setState({ isOpen: false });
      await this.props.editGuestDetail({
        Email_Guest__c: this.state.selectedRow?.Email_Guest__c
      }, Id, this.props.fetchGuestList);
      Swal.fire({
        title: "Saved!",
        text: `guest email save!`,
        type: "success"
      });
    } catch (error) {
      console.error('Error updating guest:', error);
    } finally {
      this.setState({ isLoading: false, isOpen: false });
    }
  };

  onStartFilling = async () => {
    this.setState({ isLoading: true });
    try {
      // const {guestDetail} = this.props.vf2
      // console.log(guestDetail)
      
    } catch (error) {
      console.error('Error starting guest:', error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { guestList = [], guestDetail, agentDetail } = this.props.vf2 || {};

    const statusColors = {
      "Not Started": { background: "#D0F0C0", color: "#2A5D3E" }, 
      "Started": { background: "#FFF4C2", color: "#A65E2E" },     
      "Completed": { background: "#D9E4FF", color: "#2B3A67" },    
    };

    const selectedGuest = guestDetail?.Id

    return (
      <>
        <LoadingOverlay isLoading={this.state.isLoading}/>
        <div style={{ margin: "30px", position: 'relative' }}>
          <Header title={this.props.t("GUEST LIST")} subtitle={this.props.t("trip guests")} selectedGuest={guestDetail} agent={agentDetail} />

          <Box
            sx={{
              marginTop: "30px",
              border: "1px solid #EAECF0",
              paddingTop: "24px",
              boxShadow:
                "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
              borderRadius: "8px",
              width: "100%",
            }}>
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Typography
                sx={{ color: "#101828", fontWeight: 600, fontSize: "16px", marginLeft: '24px' }}>
                {this.props.t("Guest List")}
              </Typography>
              <Box
                sx={{
                  borderRadius: "16px",
                  padding: "2px 8px",
                  background: "#EFFCF9",
                  width: "70px",
                  textAlign: "center",
                  marginLeft: '5px'
                }}>
                <Typography
                  sx={{
                    color: "#337D96",
                    fontWeight: "500",
                    fontSize: "12px",
                  }}>
                  {`${guestList.length} ${this.props.t("guests")}`}
                </Typography>
              </Box>
            </Box>

            {/* Table Guest List */}
            <Table sx={{ marginTop: "20px", border: "1px solid #EAECF0" }}>
              <TableHead sx={{ background: "#F9FAFB" }}>
                <TableRow
                  sx={{
                    ".MuiTableCell-root.MuiTableCell-head": {
                      fontSize: "12px",
                      color: "#475467",
                      fontWeight: 400,
                    },
                  }}>
                  <TableCell>#</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(guestList) && guestList.map((data, index) => (
                  <TableRow key={data.Id} onClick={() => this.handleSelectedRow(data)}>
                    <TableCell>
                      <span style={{fontSize: '14px'}}>
                        {index + 1}
                      </span>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", flexDirection: "row", alignItems:'center' }}>
                        <Avatar sx={{ backgroundColor: '#EFFCF9', marginRight: '10px', height: 30, width: 30 }}>
                          <PersonIcon sx={{ color: '#4AA1B3', fontSize: 20 }} />
                        </Avatar>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#475467",
                          }}>
                          {data.Guest_FullName__r?.Name}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ fontSize: "14px", color: "#475467", fontWeight: 300, position: "relative" }}>
                      {data.Email_Guest__c || "-"}
                      <IconButton
                        onClick={this.handleOpen}
                        sx={{
                          position: "relative",
                          top: "-2px",
                          padding: "0", 
                          marginLeft: "4px", 
                        }}
                      >
                        <Edit size="16" color="#4AA1B3" /> 
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          display: "inline-flex",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "16px",
                          background: statusColors[data.Guest_Visit_Form_2_Status__c]?.background,
                          color: statusColors[data.Guest_Visit_Form_2_Status__c]?.color,
                          minWidth: "100px",
                          padding: "0 12px",
                          width: "fit-content",
                          height: "24px",
                        }}>
                        {this.props.t(data.Guest_Visit_Form_2_Status__c) || "-"}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "0px", // Adjust the gap between buttons to be smaller
                          justifyContent: "flex-end", // Align buttons to the right
                          alignItems: "center", // Align vertically
                        }}>
                        {/* Edit Button */}
                        

                        {data.Email_Guest__c &&
                          <IconButton onClick={this.handleOpenSend}>
                            <Box
                              sx={{
                                padding: "6px",
                                paddingTop: '3px',
                                background: "#FFFFFF",
                                border: "1px solid #D0D5DD",
                                boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                                borderRadius: "8px",
                                width: "36px",
                                height: "36px", // Set height to match other buttons
                              }}>
                              {/* <Share />  */}
                              <ReplyRoundedIcon sx={{ fontSize: "24px", color: "#000", transform: "scaleX(-1)" }} />
                            </Box>
                          </IconButton>
                        }


                        <Button
                          variant="contained"
                          onClick={() => selectedGuest !== data.Id ? this.handleOpenStart(data, true) : this.handleOpenStart(data, false)}
                          sx={{
                            marginLeft:'6px',
                            fontSize: "14px",
                            padding: "6px 10px", // Adjust padding for consistent height
                            height: "36px", // Match height with icon buttons
                            backgroundColor: '#2F37B5',
                            color: '#fff',
                            textTransform: 'none',
                            '&:hover': {
                              backgroundColor: '#1E2A78', // Change hover color
                              color: '#fff',
                            },
                          }}>
                            {data.Guest_Visit_Form_2_Status__c !== 'Not Started' ? this.props.t('Edit Form') : this.props.t('Start Form')}
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>

          {/* <NavigationButtons
            nextUrl={`${URL_PREFIX}/vf2/wizard/personal`}
            onSave={this.onStartFilling}
            isLoading={this.state.isLoading}
            showNext={false}
            customNextText={`${guestDetail.Guest_Visit_Form_2_Status__c !== 'Completed' ? 'Start Filling Form' : 'Edit the Form'}`}
          /> */}
        </div>
        <GuestEditModal
          isOpen={this.state.isOpen}
          handleClose={this.handleClose}
          changeFormValue={this.changeFormValue}
          onSave={this.onSaveGuest}
          selectedRow={this.state.selectedRow}
        />
        <ConfirmationModal
          isOpen={this.state.isOpenSend}
          handleClose={this.handleCloseSend}
          onConfirm={() => this.sendURLGuest(this.state.selectedRow)}
          isLoading={this.state.isLoading}
          title={this.props.t("Send Visit Form")}
          loadingText={`${this.props.t("Sending")}...`}
          description={this.props.t("You will be sending the link to Essential Guest Information Form for {{name}}. Are you sure you want to do this?", {
            name: this.state.selectedRow?.name
          })}
        />
        <ConfirmationModal
          isOpen={this.state.isOpenStart}
          handleClose={this.handleCloseStart}
          onConfirm={() => this.changeGuest(this.state.selectedGuest)}
          isLoading={this.state.isLoading}
          title={`${this.props.t("Ready to")} ${this.state.selectedGuest.Guest_Visit_Form_2_Status__c === 'Not Started' ? this.props.t('Start the Form?') : this.props.t('Edit the Form?')}`}
          confirmText={this.props.t("Start")}
          loadingText={`${this.props.t("fetching")}...`}
          subtitle={this.state.selectedGuest?.Guest_FullName__r && `${this.props.t("Selected")}: ${this.state.selectedGuest?.Guest_FullName__r?.Name }`}
          description={this.props.t(`Once you start, you'll proceed directly to fill out the form. Make sure you're ready. Do you want to continue or cancel?`)}
        />
      </>
    );
  }
}

VF2StepGuest.propTypes = {
  vf2: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      editGuestDetail,
      fetchGuestList,
      registerGuestId,
      sendEmailUrl
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  vf2: state.vf2,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VF2StepGuest)));